import React from 'react';
import { Link } from 'react-router-dom';
import './styles/MobileHeader.css';

const MobileHeader = ({ setMobileMenuOpen, isLoggedIn }) => {
  return (
    <div className="mobile-header">
      {isLoggedIn ? (
        <div className="mobile-header-left"></div>
      ) : (
        <Link to="/welcomepage" className="mobile-header-login-button">
          Accedi
        </Link>
      )}
      
      <div className="mobile-header-center"></div>
      
      <div className="mobile-header-right">
        <div className="mobile-header-menu-icon" onClick={() => setMobileMenuOpen(true)}>
          <img src="/menu_icon/menu.png" alt="Menu" />
        </div>
      </div>
    </div>
  );
};

export default MobileHeader; 